import MyUtil from './MyUtil';

const ConvertUser = {
  handleNew: (data) => {
    let user = {
      user_acc_name: data.user.user_acc_name,
      user_acc_full_name: data.user.user_acc_full_name,
      user_acc_pass: data.inputPassword,
      user_acc_phon: data.user.user_acc_phon,
      user_acc_emai: data.user.user_acc_emai,
      user_role_id: data.roleSelected.value,
      user_part_id: data.partnerSelected.value,
      user_group_id: data.userGroupSelected.value,
    };

    user = MyUtil.clean(user);
    return user;
  },
  handleUpdate: (data) => {
    let user = {
      user_acc_id: data.user.user_acc_id,
      user_acc_name: data.user.user_acc_name,
      user_acc_full_name: data.user.user_acc_full_name,
      user_acc_phon: data.user.user_acc_phon,
      user_acc_emai: data.user.user_acc_emai,
      user_role_id: data.roleSelected.value,
      user_part_id: data.partnerSelected.value,
      user_group_id: data.userGroupSelected.value,
    };

    user = MyUtil.clean(user);
    return user;
  },
  handleCheck: (state) => {
    const { user, roleSelected, isEdit, inputPassword } = state;
    const message = [];
    if (!user.user_acc_name) message.push('username');
    if (!user.user_acc_full_name) message.push('fullname');
    if (!user.user_acc_phon) message.push('mobile');
    if (!user.user_acc_emai) message.push('email');
    if (!roleSelected.value) message.push('userType');
    if (!isEdit && !inputPassword) message.push('password');
    return message.length > 0 ? message : false;
  },
};

export default ConvertUser;
